import type { CurrencyCode, UnknownEvent } from '@faststore/sdk'
import { sendAnalyticsEvent, useSession } from '@faststore/sdk'
import { useCallback } from 'react'
import type { VariantHit } from 'src/components/algolia/algolia'
import { useAuthenticatedUserToken, useUserToken } from './useUserToken'

type Props = {
  products: VariantHit[]
}

export const useViewItemListEventSearchBar = ({ products }: Props) => {
  const {
    currency: { code },
  } = useSession()
  const userToken = useUserToken()
  const authenticatedUserToken = useAuthenticatedUserToken()

  const sendViewItemListEvent = useCallback(
    (term?: string, resultsCount?: number) => {
      const itemListName = `lt=autocomplete||topic=product||state=typing${
        term ? `||term=${term}` : ''
      }`
      // const itemListName = {
      //   lt: 'autocomplete',
      //   topic: 'product',
      //   state: 'typing',
      //   ...(term ? { term } : {}),
      // }
      const page = 1
      const pageSize = products.length
      const queryID = products[0].__queryID

      sendAnalyticsEvent<UnknownEvent>({
        name: 'view_item_list',
        params: {
          algolia_user_token: userToken,
          ...(authenticatedUserToken && {
            algolia_authenticated_user_token: authenticatedUserToken,
          }),
          item_list_name: itemListName,
          page,
          page_size: pageSize,
          queryID,
          results_count: resultsCount,
          items: products.map((variant, index) => {
            const itemCategory = variant.categoryPath.split('/')
            const isKit = variant.is_kit

            return {
              index: index + 1,
              position: index + 1,
              object_id: variant.objectID,
              item_id: variant.productId,
              item_name: variant.productName,
              item_brand: variant.brand,
              item_variant: variant.skuId,
              item_list_name: itemListName,
              // item_list_id: itemCategory.join(' '),
              item_category: itemCategory,
              quantity: 1,
              price: variant.selling_price,
              discount: +(variant.list_price - variant.selling_price).toFixed(
                2
              ),
              full_price: variant.list_price,
              discount_percentage: +(
                1 -
                variant.selling_price / variant.list_price
              ).toFixed(2),
              currency: code as CurrencyCode,
              item_variant_name: variant.skuName,
              product_reference_id: Number(variant.refId),
              coupon: null,
              unitMultiplier: variant.unit_multiplier,
              // Adding optional kit parameters
              ...(isKit && {
                bundle_label: variant.productName,
                bundle_discount: +(
                  variant.list_price - variant.selling_price
                ).toFixed(2),
                bundle_discount_percentage: +(
                  1 -
                  variant.selling_price / variant.list_price
                ).toFixed(2),
              }),
            }
          }),
        },
      })
    },
    [code, products, userToken, authenticatedUserToken]
  )

  return { sendViewItemListEvent }
}
